import { DATE_FORMAT_LONG_FNS, SYSTEM_DATE_FORMAT_FNS } from 'CorePackage/MainModule/constants/dateFormats';
import { convertInitialKnmDateToFormDate } from 'KnmPackage/MainModule/common/convertInitialKnmDateToFormDate';
import { IKnmErknmActRemark } from 'APIPackage/KnmModule/interfaces/IKnmErknmActRemark';

import { handleReactQuillDeltaValue } from '../../../functions/handleReactQuillDeltaValue';
import { IKnmErknmActRemarkForm } from '../interfaces/IKnmErknmActRemarkForm';

export function convertActRemarksToFormValues(
  remarks: IKnmErknmActRemark[] | null,
): IKnmErknmActRemarkForm[] | undefined {
  return remarks?.map(remark => {
    return {
      guid: remark.guid || undefined,
      isNew: remark.isNew || undefined,
      refusedToFamiliarize: remark.refusedToFamiliarize || undefined,
      fromEpgu: remark.fromEpgu || undefined,
      text: remark.text || undefined,
      textReactQuillEditor: handleReactQuillDeltaValue(remark.textReactQuillEditor || remark.text || undefined),
      signerFullName: remark.signerFullName || undefined,
      signerPosition: remark.signerPosition || undefined,
      date: remark.date
        ? convertInitialKnmDateToFormDate(remark.date, DATE_FORMAT_LONG_FNS, SYSTEM_DATE_FORMAT_FNS)
        : undefined,
      signatureInfo: remark.signatureInfo || undefined,
    };
  });
}
